/* --------------------------------------------------------------------------------------
   ssoClient.service.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class ssoClientService {
  /*@ngInject*/
  constructor(
    authClient,
    commonService,
    persistService,
    apiClientService,
    xeroxSsoService,
    $http,
    $httpParamSerializerJQLike,
    $window
  ) {
    this.authClientData = authClient;
    this.commonService = commonService;
    this.persistService = persistService;
    this.apiClientService = apiClientService;
    this.xeroxSsoService = xeroxSsoService;
    this.$http = $http;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.$window = $window;
  }
  async getAuthStatus(tokenData) {
    if (!tokenData || !tokenData.refreshOn) return false;

    if (moment(tokenData.refreshOn) < moment()) {
      if (!tokenData.refresh_token) return false;
      const newToken = await this.refreshToken(tokenData);
      tokenData = newToken;
    }
    return tokenData;
  }
  getUser() {
    return this.apiClientService.get("/clio/user");
  }
  getRedirectUrl() {
    const ssoData = this.getSlotAuthClientData();
    const params = {
      client_id: ssoData.clientId,
      response_type: "code",
      redirect_uri: "https://" + this.$window.location.host + "/cliosso",
    };
    return this.getAuthBaseUrl() + "/authorize?" + new URLSearchParams(params)
  }
  setTokenLocally(tokenData) {
    if (tokenData) tokenData.refreshOn = moment().add(29, "days");
    this.persistService.setObject("clioTokenData", tokenData, true);
  }
  setToken(tokenData) {
    tokenData.refreshOn = moment().add(29, "days");
    return this.xeroxSsoService.getSignupModel(tokenData);
  }
  async getToken(code) {
    const redirecturl = encodeURI("https://" + this.$window.location.host + "/cliosso")
    const result = await this.apiClientService.get("/clio/auth?code=" + code + "&redirect_url=" + redirecturl)
    return JSON.parse(result)
  }
  async refreshToken(tokenData) {
    return this.apiClientService.get("/clio/refresh?refresh_token=" + tokenData.refresh_token)
  }
  logout() {
    this.persistService.setObject("clioTokenData", null, true);
  }
  getAuthBaseUrl() {
    return this.getAuthClientData().baseUrl
  }
  getSlotAuthClientData() {
    const currentSlot = this.commonService.getCurrentSlot()
    const authClientData = this.getAuthClientData()

    switch (currentSlot) {
      case "local":
        return authClientData.local;
      case "test":
        return authClientData.test;
      case "staging":
        return authClientData.staging;
      default:
        return authClientData.prod;
    }
  }
  getAuthClientData() {
    const currentCountry = this.persistService.getObject("accountCountry")
    switch (currentCountry) {
      case 'ca':
        return this.authClientData.canada
      case 'eu':
        return this.authClientData.europe
      default:
        return this.authClientData.usa
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/ssoClient.service.js